const departments = [
    {
      name: "Equipo directivo",
      members: [
        {
          name: "Katherine Díaz",
          role: "Directora",
          image: "/team/KatherineDiaz.webp",
        },
        {
          name: "Rubén Collao",
          role: "Sostenedor",
          image: "/team/ruben-collao.webp",
        },
        {
          name: "Mariela Aguilera",
          role: "Encargada de convivencia",
          image: "/team/mariela-aguilera.webp",
        },
        // Agrega más miembros según corresponda
      ],
    },

    {
      name: "Equipo administrativo",
      members: [
        {
          name: "Paola Contreras",
          role: "Secretaria",
          image: "/team/PaolaContreras.webp",
        },
        {
          name: "Constanza Collao",
          role: "Psicóloga/Encargada Redes Sociales",
          image: "/team/constanza-collao.jpg",
        },
        // Agrega más miembros
      ],
    },

    {
      name: "Equipo fonoaudiológico",
      members: [
        {
          name: "Catalina Calderón",
          role: "Fonoaudióloga",
          image: "/team/CatalinaCalderon.webp",
        },
        {
          name: "Prissila Espinoza",
          role: "Fonoaudióloga",
          image: "/team/PrissilaEspinoza.jpg",
        },
      ],
    },

    {
      name: "Equipo docente",
      members: [
        {
          name: "Katherine Díaz",
          role: "Docente",
          image: "/team/KatherineDiaz.webp",
        },
        {
          name: "Jessica Navarro",
          role: "Docente",
          image: "/team/JessicaNavarro.webp",
        },
        {
          name: "Elizabeth Castro",
          role: "Docente",
          image: "/team/ElizabethCastro.webp",
        },
        {
          name: "Sofía Alarcón",
          role: "Educadora diferencial",
          image: "/team/SofiaAlarcon.jpg",
        },
        {
          name: "Angelina Campaña",
          role: "Docente",
          image: "/team/AngelinaCampana.webp",
        },           
      ],
    },

    {
      name: "Equipo Técnico en educación parvularia ",
      members: [
        {
          name: "Úrsula Pizarro",
          role: "Técnico en educación parvularia",
          image: "/team/UrsulaPizarro.webp",
        },
        {
          name: "Vilma Hidalgo",
          role: "Técnico en educación parvularia",
          image: "/team/VilmaHidalgo.webp",
        },
        {
          name: "Priscila Erazo",
          role: "Técnico en educación parvularia",
          image: "/team/PriscilaErazo.webp",
        },
        {
          name: "Pía Rissetto",
          role: "Instructora de yoga infantil",
          image: "/team/PiaRissetto.jpg",
        },
      ],
    },
  ]
  // Otros departamentos...
  export default departments
  